module.exports = __webpack_public_path__ + "img/austria-infectious-diseases-male.0ae265ed.png";